<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/hero-img-dl.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="hero-containt position-relative">
            <router-link to="/digitalleaders"
              ><img src="assets/img/DL_bleu-web-big.png" alt=""
            /></router-link>
            <p>
              The rankings will be released on May 10th at 12.00 GMT
            </p>

            <div class="hero-global">
              <p>A new date for the release will be announced soon</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
// import CountDown from '@/components/CountDown';
export default {
  components: {
    // CountDown
  },
  data() {
    return {
      textElements: {}
    };
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}
</style>
